module.exports = __webpack_public_path__ + "img/signing.88419cd9.svg";